import React from 'react'
import './Game.css'

// images
import girl_1 from '../../images/girl_1.png'
import girl_2 from '../../images/girl_2.png'
import girl_3 from '../../images/girl_3.png'
import wizard_1 from '../../images/wizards_1.png'
import wizard_2 from '../../images/wizard_2.png'
import wizard_3 from '../../images/wizard_3.png'
import wizard_4 from '../../images/wizard_4.png'
import synthera_1 from '../../images/synthera_1.png'
import synthera_2 from '../../images/synthera_2_crop.png'
import console from '../../images/console.png'
import github from '../../images/github.png'
// import faire_1 from '../../images/faire_1.png'
// import faire_2 from '../../images/faire_2.png'

// Swiper 
import { Swiper, SwiperSlide, SwiperClass} from 'swiper/react'
import { Pagination, Navigation } from 'swiper/modules'
import 'swiper/css' // core Swiper
import 'swiper/css/navigation'
import 'swiper/css/pagination'
// import 'swiper/modules/navigation/navigation.scss'; // Navigation module
// import 'swiper/modules/pagination/pagination.scss'; // Pagination module


type GameProps = {
    images: string[] // source paths
    tags: string[]
    overview: string
    skills: string
    technical: string
    playLink: string
    gitLink: string
}

const getImgSrc = (key: string)  => {
  switch(key) {
    case 'girl_1':
      return girl_1
    case 'girl_2':
      return girl_2
    case 'girl_3':
      return girl_3
    case 'wizard_1':
      return wizard_1
    case 'wizard_2':
      return wizard_2
    case 'wizard_3':
      return wizard_3
    case 'wizard_4':
      return wizard_4
    case 'synthera_1':
      return synthera_1
    case 'synthera_2':
      return synthera_2
  } 
}

export const Game = ({images, tags, overview, skills, technical, playLink, gitLink}: GameProps) => { 
  
  
  return (
  <div className='gameWrapper'>
    <div className='gameHeader'>
      <div className='gameOverview'>{overview} </div>
    </div>

      <Swiper pagination={true} navigation={true} modules={[Pagination, Navigation]} rewind={true}>
        {images.map((imageSrcString: string) => {
          return (
            <SwiperSlide>
              <img src={getImgSrc(imageSrcString)} className='swiperImg' alt=''/>
            </SwiperSlide>
          )
        })}
      
      </Swiper>

      <div className='gameLinks'>
        {(playLink != '') && (<a href={playLink} target="_blank" rel="noopener noreferrer">
          <div className='gameLink'>
            <img className='linkIcon' src={console} width={'50px'} height={'50px'}></img> <p>Play here!</p>
          </div>
          </a>)}
        {(gitLink != '') && (<a href={gitLink} target="_blank" rel="noopener noreferrer">
          <div className='gameLink'>
            <img className='linkIcon' src={github} width={'45px'} height={'45px'}></img> <p>View the code</p>
          </div>
        </a>)}
      </div>

    <div className='gameTextWrapper'>
      <h2>What I worked on</h2>
      <div>{skills}</div>
    </div>
  </div>
)};